import React from 'react';
import { PackCardSkeleton } from './PackCardSkeleton';

/**
 * Componente PacksGridSkeleton - Muestra skeletons para el grid de packs
 * 
 * Este componente muestra múltiples skeletons de PackCard en un grid
 * para simular el estado de carga de la lista de packs.
 */
export const PacksGridSkeleton = React.memo(() => {
  // Mostrar 12 skeletons (3 filas x 4 columnas en pantallas grandes)
  const skeletonCount = 12;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <PackCardSkeleton key={`skeleton-${index}`} />
      ))}
    </div>
  );
});

PacksGridSkeleton.displayName = 'PacksGridSkeleton';

export default PacksGridSkeleton;

